import { Component, Input }    from '@angular/core';

@Component({
  template: require('./vehicle.history.row.expand.component.html')
})
export class VehicleHistoryRowExpandComponent {
  @Input() record: any;
}
